import { Helmet } from "react-helmet";
import DashboardLayout from "@/components/layouts/DashboardLayout";

const Support = () => {
  return (
    <DashboardLayout>
      <Helmet>
        <title>Support - Numberz Insight</title>
        <meta name="description" content="Get help and support for your account." />
      </Helmet>

      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-semibold mb-6">Help & Support</h1>
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg">
          <p className="text-gray-600 dark:text-gray-300">Support features coming soon.</p>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Support;